/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../Fixes';
import Builder from '../../../../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "common": {
                            "nested": {
                              "PaymentTypes": {
                                "fields": {
                                  "skipPaymentTypeSelection": {
                                    "type": "bool",
                                    "id": 1,
                                    "rule": "optional",
                                    "options": {
                                      "default": true
                                    }
                                  },
                                  "skipItemizedCart": {
                                    "type": "bool",
                                    "id": 2,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  },
                                  "skipReviewSale": {
                                    "type": "bool",
                                    "id": 3,
                                    "rule": "optional",
                                    "options": {
                                      "default": true
                                    }
                                  },
                                  "tenderSettings": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.TenderSettings",
                                    "id": 4,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "TenderSettings": {
                                "fields": {
                                  "primaryTender": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.TenderSettings.TenderType",
                                    "id": 1,
                                    "rule": "repeated"
                                  },
                                  "secondaryTender": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.TenderSettings.TenderType",
                                    "id": 2,
                                    "rule": "repeated"
                                  },
                                  "disabledTender": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.TenderSettings.TenderType",
                                    "id": 3,
                                    "rule": "repeated"
                                  },
                                  "hasPrimaryTender": {
                                    "type": "bool",
                                    "id": 4,
                                    "rule": "optional",
                                    "options": {
                                      "default": true
                                    }
                                  },
                                  "hasSecondaryTender": {
                                    "type": "bool",
                                    "id": 5,
                                    "rule": "optional",
                                    "options": {
                                      "default": true
                                    }
                                  },
                                  "hasDisabledTender": {
                                    "type": "bool",
                                    "id": 6,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  }
                                },
                                "nested": {
                                  "TenderType": {
                                    "values": {
                                      "UNKNOWN": 0,
                                      "CARD": 1,
                                      "GIFT_CARD": 2,
                                      "CASH": 3,
                                      "INVOICE": 4,
                                      "CARD_ON_FILE": 5,
                                      "E_MONEY": 6,
                                      "INSTALLMENTS": 7,
                                      "CHECKOUT_LINK": 8,
                                      "DEFERRED_PAY": 9,
                                      "PUSH": 10,
                                      "CHECKOUT_LINK_QR_CODE": 11,
                                      "PUSH_PAYPAY": 12,
                                      "PUSH_ALIPAY_CN": 13,
                                      "HOUSE_ACCOUNTS": 14,
                                      "CHECK": 15,
                                      "MERCHANT_GIFT_CARD": 16,
                                      "OTHER": 17,
                                      "DEBIT": 18,
                                      "CREDIT_OR_DEBIT": 19,
                                      "RECORD_E_MONEY": 20,
                                      "DEBIT_OR_CREDIT": 21,
                                      "THIRD_PARTY_CARD": 22,
                                      "MEAL_VOUCHER": 23,
                                      "BITCOIN": 24,
                                      "STORED_VALUE": 25
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.PaymentTypes && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.TenderSettings && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.TenderSettings?.nested?.TenderType) {
  $root.addJSON(jsonData);
}

/**
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE PaymentTypes @ squareup/devicesettings/profiles/v2/model/settings/common/payment_types.proto at 17:1
 */
export const PaymentTypes = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.common.PaymentTypes');
fixType(PaymentTypes);
Builder.createAndAttachToType(PaymentTypes);
/**
 * SOURCE TenderSettings @ squareup/devicesettings/profiles/v2/model/settings/common/payment_types.proto at 24:1
 */
export const TenderSettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.common.TenderSettings');
fixType(TenderSettings);
Builder.createAndAttachToType(TenderSettings);
/**
 * SOURCE TenderType @ squareup/devicesettings/profiles/v2/model/settings/common/payment_types.proto at 31:3
 */
TenderSettings.TenderType = $root.lookupEnum('squareup.devicesettings.profiles.v2.model.settings.common.TenderSettings.TenderType').values;